import { observer } from 'mobx-react';
import React from 'react';
import { Button, Card, CardContent, Container, Grid, GridColumn, Heading, Notice, Select, Separator, Spinner, Text } from 'telia-front-react';
import { TranslationsContext } from '@teliaee/telia-translate';
import ConstructorPortalStore, { LinkType } from '../stores/ConstructorPortalStore';
import SsoStore from '../stores/SsoStore';
import { useStores } from '../stores/RootStore';

export interface ConstructorPortalProps {
  constructorPortalStore?: ConstructorPortalStore;
  ssoStore?: SsoStore;
}

export const ConstructorPortal = observer(() => {
  const { constructorPortalStore, ssoStore } = useStores();
  const { addressOptions, isEntryInformationFetching, loadEntryInformation, handleAddressSelection, postData, selectedAddressOption } = constructorPortalStore;
  const { translate } = React.useContext(TranslationsContext);

  React.useEffect(() => {
    loadEntryInformation();
  }, [ssoStore.customerId]);

  if (isEntryInformationFetching || !ssoStore.initialSsoMessageReceived) {
    return <Spinner />;
  }

  if (!ssoStore.hasLegalOrServiceTeliaMandate) {
    return (
      <Container>
        <Notice type="error">{translate('constructor-portal.error.noMandate')}</Notice>
      </Container>
    );
  }

  if (addressOptions?.length < 1) {
    return (
      <Container>
        <Notice type="error">{translate('constructor-portal.error.noAddress')}</Notice>
      </Container>
    );
  }

  return (
    <Container>
      <Heading level={1} className="h3">
        {translate('constructor-portal.page.title')}
      </Heading>
      <Separator color="invisible" spacing="small" />
      <Card padding="medium" background="neutral-bg-level-1" type="light">
        <CardContent>
          <Text>
            <Heading element="h4" className="h4 text-bold">
              {translate('constructor-portal.heading.title')}
            </Heading>
            <Separator color="invisible" spacing="small" />
            <Select
              id="constructor-portal-select-field"
              label={translate('constructor-portal.select.field.label')}
              placeholder={translate('constructor-portal.select.field.placeholder')}
              options={addressOptions}
              defaultValue={selectedAddressOption}
              onChange={handleAddressSelection}
            />
            <Separator color="invisible" spacing="small" />
            <Grid gutter="small">
              <GridColumn width={['lg-12']}>
                <Button iconLeft="#map-marker" link text={translate('constructor-portal.link.geodeet')} onClick={() => postData(LinkType.GEODEET)} />
              </GridColumn>
              <GridColumn width={['lg-12']}>
                <Button iconLeft="#password-show" link text={translate('constructor-portal.link.jarelvalve')} onClick={() => postData(LinkType.JARELVALVE)} />
              </GridColumn>
              <GridColumn width={['lg-12']}>
                <Button iconLeft="#file-settings" link text={translate('constructor-portal.link.tehniline')} onClick={() => postData(LinkType.TEHNILINE)} />
              </GridColumn>
              <GridColumn width={['lg-12']}>
                <Button
                  iconLeft="#file-check"
                  link
                  text={translate('constructor-portal.link.kooskolastamine')}
                  onClick={() => postData(LinkType.KOOSKOLASTAMINE)}
                />
              </GridColumn>
            </Grid>
          </Text>
        </CardContent>
      </Card>
    </Container>
  );
});
